export interface OrganizationConnectionIntentListResponse {
  id: string
  companyToken: string
}

export class OrganizationConnectionIntentListModel {
  public id: string
  public companyToken: string

  public constructor(data: OrganizationConnectionIntentListResponse) {
    this.id = data.id
    this.companyToken = data.companyToken
  }
}
